import { SelectArrow } from "@/shared/components/ui/icons"
import { Menu, useMenu } from "../../index.ts"

interface Props {
  options?: number[]
  getLabel?: (value: number, total?: number) => string
  onPerPageChange: (value: number) => void
  perPage: number
  total?: number
}
const PerPageSelect = ({ perPage, total, options, onPerPageChange, getLabel }: Props) => {
  const { targetProps, menuProps, open, setOpen } = useMenu()
  return (
    <div className="flex items-center">
      <div
        {...targetProps}
        className="flex child:grid child:w-9 w-fit child:place-items-center child:items-center child:bg-pagination-bg child:p-2 child:px-3"
      >
        <div className="rounded-s-lg px-4">{perPage}</div>
        <button className="flex items-center justify-center rounded-tr-lg rounded-br-lg">
          {open ? <SelectArrow size={16} className="rotate-180" /> : <SelectArrow size={16} />}
        </button>
      </div>
      {total != null && <div className="ml-4 flex items-center">{getLabel?.(perPage, total) ?? `из ${total}`}</div>}
      <Menu {...menuProps}>
        {(options ?? [50, 40, 30, 20, 10]).map((option, index) => (
          <Menu.Item
            className="justify-center"
            key={index}
            onClick={() => {
              onPerPageChange(option)
              setOpen(false)
            }}
            label={String(option)}
          />
        ))}
      </Menu>
    </div>
  )
}

export default PerPageSelect
